import React, { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import "@/index.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Services } from "@/components/Services";
import { Aircon } from "@/components/Aircon";
import { Roamwire } from "@/components/Roamwire";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { Faq } from "@/components/Faq";
import { ContactClose } from "@/components/ContactClose";
import { Footer } from "@/components/Footer";
import { LiveRatingProvider } from "@/components/LiveRatingProvider";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-slate-200 font-sans px-6 text-center">
          <p>
            Something's not loading right — call Sam on 0413 700 692 and he'll
            sort you out.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Page = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute("href");
      if (hash.length > 1) {
        const el = document.querySelector(hash);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-ink text-slate-50 font-sans overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <Aircon />
        <Roamwire />
        <Reviews />
        <About />
        <Faq />
        <ContactClose />
      </main>
      <Footer />
      {/* grain overlay */}
      <div
        aria-hidden="true"
        className="grain pointer-events-none fixed inset-0 z-[60] opacity-[0.05]"
      />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <LiveRatingProvider>
        <Page />
      </LiveRatingProvider>
    </ErrorBoundary>
  );
}

export default App;
